













import Vue from 'vue';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import SearchForm from './components/SearchForm.vue';

export default Vue.extend({
  name: 'App',

  components: {
    Header,
    SearchForm,
    Footer,
  },

  data: () => ({
    //
  }),
});
